(() => {
    const $uploadInputBoxes = document.querySelectorAll('.upload-input-box');

    const initUploadInputBoxes = () => {
        if (!$uploadInputBoxes) return;

        $uploadInputBoxes.forEach($uploadInputBox => {
            const $button = $uploadInputBox.querySelector('.upload-input-box__button');
            const $input = $uploadInputBox.querySelector('.upload-input-box__input');
            const $filename = $uploadInputBox.querySelector('.upload-input-box__filename');

            $button.addEventListener('click', () => {
                $input.click();
            });

            if ($input) {
                $input.addEventListener('change', () => {
                    if (Array.from($input.files).length) {
                        $uploadInputBox.classList.add('upload-input-box--has-file');

                        $filename.textContent = Array.from($input.files).map(file => file.name).join(', ');
                    } else {
                        $uploadInputBox.classList.remove('upload-input-box--has-file');
                        $filename.textContent = '';
                    }
                });
            }
        });
    };

    initUploadInputBoxes();
})();
